import $ from "jquery"
import GroupManagementUtil from "./group_management_util"
import messageResource from "../messageResource"
import RpcControlManager from "../rpc_control_manager"
import {cancelBubble, addClass, removeClass} from "../atBrowserUtils"
import {escapeHtmlSymbols} from "../atUtils"

/**
 * Handle all operations with add user group row in lightbox
 */
export default class AddGroupController {
    /**
     * @param config.newGroupInputId input for new group name
     * @param config.newGroupInputCellId cell, where newGroupInputId situates
     * @param config.addGroupButtonId button for accept new group creation
     * @param config.addGroupRowId common element of all controls
     * @param config.rowHighlightedClassName class name for highlighted row
     * @param config.ajaxProcessingClassName class name for paint row as ajax processd
     * @param config.waitingAnimationCellId cell with animation needed for ajax
     * @param config.spinnerController spinner controller
     */
    init(config) {
        this.newGroupInputId = config.newGroupInputId;
        this.newGroupInputCellId = config.newGroupInputCellId;
        this.addGroupButtonId = config.addGroupButtonId;
        this.addGroupRowId = config.addGroupRowId;
        this.rowHighlightedClassName = config.rowHighlightedClassName;
        this.ajaxProcessingClassName = config.ajaxProcessingClassName;
        this.waitingAnimationCellId = config.waitingAnimationCellId;
        this.groupNamingKey = config.groupNamingKey;
        this.GroupNamingKey = config.GroupNamingKey;
        this.spinnerController = config.spinnerController;
        return this;
    }

    /**
     * Init controller
     * @param controller user group management controller
     */
    initAfterShowing(controller) {

        this.newGroupInput = document.getElementById(this.newGroupInputId);
        this.newGroupInputCell = document.getElementById(this.newGroupInputCellId);
        this.addGroupButton = document.getElementById(this.addGroupButtonId);
        this.addGroupRow = document.getElementById(this.addGroupRowId);
        this.waitingAnimationCell = document.getElementById(this.waitingAnimationCellId);

        this.initFieldController(controller);
        const context = this;

        this.changeButtonState(controller, true);

        this.newGroupInput.onkeyup = function(event) {
            GroupManagementUtil.createNoEnterAndEscPressedHandler(event, function() {
                const isEmpty = context.emptyFieldController.isEmpty();
                controller.passiveEventHandler(function() {context.changeButtonState(controller, isEmpty)}, false);
                //Fix for FF bug. If field is empty FF places cursor at the end of the input.
                if (isEmpty) {
                    context.newGroupInput.blur();
                    context.newGroupInput.focus();
                }
            });
        };

        this.newGroupInput.onkeydown = function(event) {
            cancelBubble(event);
            GroupManagementUtil.createEscPressedHandler(event, function() {
                context.resetRowIntoDefaultState();
            });
            GroupManagementUtil.createEnterPressedHandler(event, function() {controller.groupEventHandler(function() {context.createUserGroup(controller)}, false)});
        };

        this.newGroupInput.onblur = function(event) {
            const isEmpty = context.emptyFieldController.isEmpty();
            controller.passiveEventHandler(function() {
                context.defineHighlightingState(isEmpty);
                context.changeButtonState(controller, isEmpty);
            }, false);
        };

        this.newGroupInput.onfocus = function(event) {
            controller.passiveEventHandler(function() {context.highlightRow()}, false);
        };
    }

    /**
     * Init field controller needed for paint empty caption
     */
    initFieldController() {
        this.emptyFieldController = new EnhancedFieldController();
        this.emptyFieldController.emptyCaption = this.getNewGroupFieldEmptyCaption();
        this.emptyFieldController.init(this.newGroupInput.id);
    }

    getNewGroupFieldEmptyCaption() {
        return messageResource.getMessage("group_management.new_user_group", [messageResource.getMessage(this.GroupNamingKey)]);
    }

    /**
     * Change state of all row controls in dependence of input field emptiness
     * @param controller user group management controller
     */
    changeStateIfNeeded(controller) {
        const isEmpty = this.emptyFieldController.isEmpty();
        this.changeButtonState(controller, isEmpty);
        this.defineHighlightingState(isEmpty);
    }

    /**
     * Enable or disable add new user group button
     * @param controller user group management controller
     * @param isEmpty is input field empty
     */
    changeButtonState(controller, isEmpty) {
        const isDisabledButton = isEmpty || controller.isAJAXRequestProcessedNow;

        $(this.addGroupButton).toggleClass("disabled", isDisabledButton);

        const context = this;
        this.addGroupButton.onclick = isDisabledButton ?
                                      function() {} :
                                      function() {
                                          controller.groupEventHandler(function() {context.createUserGroup(controller)}, false);
                                      };
    }

    /**
     * Paint border of a input as solid
     */
    highlightRow() {
        addClass(this.newGroupInputCell, this.rowHighlightedClassName);
    }

    unhighlightRow() {
        removeClass(this.newGroupInputCell, this.rowHighlightedClassName);
    }

    /**
     * Define state of row highlighting in dependence of input field emptiness
     * @param isEmpty is input filed empty
     */
    defineHighlightingState(isEmpty) {
        const context = this;
        if (isEmpty) {
            this.unhighlightRow();
            $(this.newGroupInputCell).hover(
                    function(e) {
                        context.highlightRow();
                    },
                    function(e) {
                        context.unhighlightRow();
                    }
            );
        } else {
            this.highlightRow();
            $(this.newGroupInputCell).off("hover");
        }
    }

    /**
     * Create new user group
     * @param controller user group management controller
     */
    createUserGroup(controller) {
        const context = this;
        if (this.emptyFieldController.isEmpty()) {
            return;
        }
        if (controller.getGroupController().isDuplicateName(this.newGroupInput.value)) {
            window.setTimeout(function() {
                const errorMessage = messageResource.getMessage("group_management.error.duplicate_name.user_group", [messageResource.getMessage(context.GroupNamingKey)]);
                GroupManagementUtil.markCellAsInvalid(context.newGroupInputCell, errorMessage);
                controller.showErrorMessage(escapeHtmlSymbols(errorMessage));
            }, 100);
        } else {
            controller.isChangesMade = true
            this.createUserGroupRpc(controller);
        }
    }

    createUserGroupRpc(controller) {
        const manager = new GroupCreateRPCManager(controller.getServiceName(), controller, this.getNewGroupData(), this.GroupNamingKey);
        RpcControlManager.saveRpcControlBoundData(manager, false);
        this.spinnerController.spin(this.waitingAnimationCellId);
    }

    getNewGroupData() {
        return {
            id: -1,
            name: this.newGroupInput.value
        }
    }

    /**
     * Paint row as ajax processed when new user group saving begins
     */
    markRowAsAJAXProcessedNow() {
        addClass(this.addGroupRow, this.ajaxProcessingClassName);
        this.newGroupInput.disabled = "disabled";
        this.waitingAnimationCell.style.display = "table-cell";

    }

    /**
     * Reset add user group row into default state
     */
    resetRowIntoDefaultState() {
        removeClass(this.addGroupRow, this.ajaxProcessingClassName);
        this.newGroupInput.disabled = "";
        this.newGroupInput.value = "";
        this.waitingAnimationCell.style.display = "none";
        this.changeStateIfNeeded();
        this.newGroupInput.blur();
        this.emptyFieldController.showGreyTextIfEmpty();
        this.spinnerController.stop();
    }
}











































// WEBPACK FOOTER //
// ./web/js/groupManagement/add_group_controller.js